import set from 'lodash/set';

import type {
  PageResponse,
  ComponentResponse,
  DataEndpoint,
} from '../../../../types';

type TaxonomyParams = Record<string, unknown> & {
  filter?: Record<string, unknown>;
};

const CATEGORY_FILTER_ENDPOINTS: DataEndpoint[] = [
  'svp/assets',
  'svp/search',
  'svp/most-seen',
];

/**
 * Overrides data source params based on page taxonomy if component.usePageTaxonomy is enabled.
 * Used to present correct (overridden) badges in components preview and list.
 */
function applyPageTaxonomyParams(
  page: PageResponse | undefined,
  component: ComponentResponse,
  params: TaxonomyParams
): TaxonomyParams {
  const pageType = page?.type;
  const templateType = pageType === 'template' ? page?.forType : undefined;

  const hasCategoryTaxonomy =
    pageType === 'category' || templateType === 'category';

  const hasTagTaxonomy = pageType === 'tag' || templateType === 'tag';

  // clone nested objects to avoid mutations of the original one
  const paramsWithTaxonomy: TaxonomyParams = {
    ...params,
    filter: { ...params.filter },
  };

  if (component.options?.usePageTaxonomy) {
    const endpoint = component.data?.source?.endpoint;
    if (hasCategoryTaxonomy) {
      if (endpoint && CATEGORY_FILTER_ENDPOINTS.includes(endpoint)) {
        set(paramsWithTaxonomy, 'filter.categoryId', '«from page»');
      }

      if (endpoint === 'svp/categories') {
        set(paramsWithTaxonomy, 'filter.parentId', '«from page»');
      }

      if (endpoint === '/profiles') {
        set(paramsWithTaxonomy, 'categoryId', '«from page»');
      }
    }

    if (hasTagTaxonomy) {
      if (endpoint === 'svp/assets') {
        set(paramsWithTaxonomy, 'filter.tagId', '«from page»');
      }

      if (endpoint === 'svp/search') {
        set(paramsWithTaxonomy, 'filter.tagsid', '«from page»');
      }
    }
  }

  return paramsWithTaxonomy;
}

export { applyPageTaxonomyParams };
